<template>
  <div class="profile mt-5">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header>
            <h2 class="text-right rtl font-18 mb-4">اطلاعات اولیه</h2>
            <p v-if="bio && bio.user_id">
              پروفایل خود را
              <router-link :to="'/user/'+bio.user_id">اینجا</router-link>
              ببینید
            </p>
            <p v-if="isUrl">
              برای مشاهده صفحه اختصاصی خود
              <router-link :to="'/'+url">
                اینجا
              </router-link>
              کلیک کنید
            </p>
          </header>
        </div>
      </div>
      <b-tabs>
        <b-tab title="اطلاعات شخصی">
          <b-card>
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="profile-avatar text-center">
                    <img :src="bioImage" :alt="bio.fullname" class="profile-img"/>
                    <upload-avatar :hasBio="bio.img" v-if="bio"/>
                  </div>
                </div>
                <div class="col-12 col-md-9">
                  <div class="row pt-5">
                    <div class="col-12 col-md-4">
                      <div class="group-form">
                        <input
                          type="text"
                          v-validate="'required'"
                          name="نام ونام خانوادگی"
                          :class="{active:bio.fullname != '' }"
                          v-model="bio.fullname"
                        />
                        <span class="bar"></span>
                        <label class="statr">نام و نام خانوادگی</label>
                        <span v-if="errors.has('نام ونام خانوادگی')" class="is-danger">فیلد نباید خالی باشد</span>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="group-form">
                        <input
                          type="text"
                          v-validate="'required'"
                          name="کد ملی"
                          :class="{active:bio.national_number != '' }"
                          v-model="bio.national_number"
                          maxlength="11"
                        />
                        <span class="bar"></span>
                        <label class="statr">کد ملی</label>
                        <span
                          v-if="errors.has('کد ملی')"
                          class="is-danger"
                        >فیلد نباید خالی باشد</span>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <div class="group-form">
                        <input
                          type="text"
                          v-validate="'required'"
                          name="شغل"
                          :class="{active:bio.jobPos != '' }"
                          v-model="bio.jobPos"
                        />
                        <span class="bar"></span>
                        <label class="statr">عنوان شغلی</label>
                        <span v-if="errors.has('شغل')" class="is-danger">فیلد نباید خالی باشد</span>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="group-form">
                        <input
                          type="text"
                          v-validate="'required'"
                          name="آدرس محل کار"
                          :class="{active:bio.workPlace != '' }"
                          v-model="bio.workPlace"
                        />
                        <span class="bar"></span>
                        <label class="statr">محل کار</label>
                        <span v-if="errors.has('آدرس محل کار')" class="is-danger">فیلد نباید خالی باشد</span>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="group-form">
                        <input
                          type="text"
                          v-validate="'required|numeric'"
                          name="شماره موبایل"
                          :class="{active:bio.phonenumber != '' }"
                          v-model="bio.phonenumber"
                          maxlength="11"
                        />
                        <span class="bar"></span>
                        <label class="statr">شماره تماس</label>
                        <span
                          v-if="errors.has('شماره موبایل')"
                          class="is-danger"
                        >فیلد نباید خالی باشد</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="editor rtl text-right my-4">
                    <label class="statr">بیوگرافی</label>
                    <!-- <input type="hidden" v-validate="item.rule" :name="item.name"  v-model="item.model"> -->
                    <!-- <quill-editor @ready="onEditorReady($event)" v-model="bio.about" /> -->
                    <tinymce-editor v-model="bio.about" api-key="5jvyaeru3nfs1qb04au0hymmsfyrhspqo7qg0xp8cnc8ptl6"
                                    :init="configEditor"></tinymce-editor>
                    <input type="hidden" v-validate="'required'" name="بیوگرافی" v-model="bio.about">
                    <div class="group-form">
                    <span
                      v-if="errors.has('بیوگرافی')"
                      class="text-red font-16 mt-2"
                    >بیوگرافی خود را تکمیل کنید.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
          <div class="row">
            <div class="col-12">
              <header class="pt-4">
                <h2 class="text-right rtl font-18 mb-4">شبکه های اجتماعی</h2>
              </header>
            </div>
          </div>
          <b-card>
            <div class="container-fluid">
              <div class="row py-4">
                <div class="col-md-4">
                  <div class="group-form-social mod-ltr">
                    <strong class="text-left ltr d-inline-block holder">www.instagram.com/</strong>
                    <input
                      type="text"
                      name="instagram"
                      :class="{active:bio.instagram != '' }"
                      v-model="bio.instagram"
                    />

                    <label>اینستاگرام</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="group-form-social mod-ltr">
                    <strong class="text-left ltr d-inline-block holder">www.twitter.com/</strong>
                    <input
                      type="text"
                      name="twitter"
                      :class="{active:bio.twitter != '' }"
                      v-model="bio.twitter"
                    />

                    <label>تویتر</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="group-form-social mod-ltr">
                    <strong class="text-left ltr d-inline-block holder">www.linkedin.com/in/</strong>
                    <input
                      type="text"
                      name="facebook"
                      :class="{active:bio.facebook != '' }"
                      v-model="bio.facebook"
                    />

                    <label>لینکدین</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="group-form-social mod-ltr">
                    <strong class="text-left ltr d-inline-block holder">www.t.me/</strong>
                    <input
                      type="text"
                      name="telegram"
                      :class="{active:bio.telegram != '' }"
                      v-model="bio.telegram"
                    />

                    <label>تلگرام</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="group-form-social mod-ltr">
                    <strong class="text-left ltr d-inline-block holder">http://</strong>
                    <input
                      type="text"
                      name="website"
                      :class="{active:bio.website != '' }"
                      v-model="bio.website"
                    />

                    <label>وب سایت</label>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
          <div class="row">
            <div class="col-12">
              <header class="pt-4">
                <h2 class="text-right rtl font-18 mb-4">اطلاعات بانکی</h2>
              </header>
            </div>
          </div>
          <b-card class="mb-5">
            <div class="row">
              <div class="col-12">
                <p>توضیح : ورود اطلاعات بانکی صرفا برای مدرسین جهت انجام تسویه حساب درآمد مدرسین الزامی می باشد. سایر
                  کاربران می توانند هنگام بروزرسانی پروفایل خود در قسمت اطلاعات بانکی (در هر سه فیلد درخواستی) عدد 0 را
                  وارد نمایند.</p>
              </div>
            </div>
          </b-card>
          <b-card class="mb-5">
            <div class="row py-4">
              <div class="col-12 col-md-4">
                <div class="group-form">
                  <input
                    type="text"
                    v-validate="'required'"
                    name="کارت بانکی"
                    :class="{active:bio.credit_card_number != '' }"
                    v-model="bio.credit_card_number"
                  />
                  <span class="bar"></span>
                  <label class="statr">شماره کارت</label>
                  <span
                    v-if="errors.has('کارت بانکی')"
                    class="is-danger"
                  >فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="group-form">
                  <input
                    type="text"
                    v-validate="'required'"
                    name="شماره حساب"
                    :class="{active:bio.bank_account_number != '' }"
                    v-model="bio.bank_account_number"
                  />
                  <span class="bar"></span>
                  <label class="statr">شماره حساب</label>
                  <span
                    v-if="errors.has('شماره حساب')"
                    class="is-danger"
                  >فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="group-form">
                  <input
                    type="text"
                    v-validate="'required'"
                    name="نام بانک"
                    :class="{active:bio.bank_name != '' }"
                    v-model="bio.bank_name"
                  />
                  <span class="bar"></span>
                  <label class="statr">نام بانک</label>
                  <span v-if="errors.has('نام بانک')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="form-action mt-2">
                  <button
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                    v-ripple
                    @click="updateBio"
                  >بروزرسانی پروفایل
                  </button>
                </div>
              </div>
            </div>
          </b-card>
        </b-tab>
        <!-- @click="checkInstructorSpecial" -->
        <b-tab @click="checkInstructorSpecial" title="ایجاد صفحه اختصاصی مدرس" v-if="instructor">
          <b-card class="mb-5">
            <div class="row">
              <div class="col-12">
                <p>
                  شما نیز می توانید تبدیل به یکی از مدرسین ویژه مادیا شوید و از مزایای آن جهت رشد و بهتر دیده شدن و
                  ایجاد برندینگ شخصی استفاده نمایید.
                </p>
                <p>
                  سپس می توانید از طریق این قسمت درخواست صفحه اختصاصی با نام دلخواه خودتان را داشته باشید، مثال :
                </p>
                <p>
                  www.madya.ir/teachername
                </p>
                <p>
                  مزایای داشتن صفحه اختصاصی:
                </p>
                <p>
                  - نمایش دوره ها و مقالات شما در صفحه اختصاصی خودتان
                </p>
                </p>
                <p>
                  - بهره مندی از سهم بیشتر از فروش دوره (20% بیشتر نسبت به سهم پیشفرض)
                </p>
                <p>
                  - بازاریابی ،فروش و برندینگ شخصی در صفحه شخصی خود
                </p>
                <p>
                  - داشتن یک رزومه کامل بصورت یکجا از فعالیت های آموزشی خود
                </p>
                <p>هم اکنون می توانید صفحه اختصاصی خودتان را بسازید و وارد کلوب مدرسین ویژه مادیا گردید.</p>
              </div>
              <div class="col-12 col-md-6">
                <div class="group-form-social mod-ltr">
                  <strong class="text-left ltr d-inline-block holder">www.madya.ir/</strong>
                  <input
                    type="text"
                    name="url"
                    :disabled="isUrl"
                    :class="{active:url != '' }"
                    v-model="url"
                  />
                  <label>لینک شخصی</label>
                </div>
              </div>
            </div>
            <div class="row" v-if="!isUrl">
              <div class="col">
                <div class="form-action mt-2">
                  <button
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                    v-ripple
                    @click="join"
                  >ایجاد صفحه اختصاصی
                  </button>

                </div>
              </div>
            </div>
          </b-card>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
  import uploadAvatar from "cp/dashboard-component/upload-avatar/index";

  export default {
    name: "profile",
    components: {
      uploadAvatar
    },
    data() {
      return {
        userAvatar: undefined,
        isLoading: false,
        url: "",
        instructor: false
      };
    },
    computed: {
      isUrl() {
        return !!(this.$store.state.dashboardProfile.url)
      },
      configEditor: () => ({
        menubar: false,
        toolbar: [
          "undo redo | bold italic | link | numlist bullist  | styleselect"
        ],
        plugins: ["link lists"],
        file_picker_types: "image",
        language: "fa_IR",
        height: 300,
        language_url: "https://admin.salameno.ir/static/libs/tinymce/langs/fa_IR.js",
        directionality: "rtl",
      }),
      uploadPercentage() {
        return this.$store.state.dashboardProfile.uploadPercentage;
      },
      bio() {
        return this.$store.state.dashboardProfile.bio;
      },
      bioImage() {
        if (!this.bio) return "../../static/img/avatar.png";
        if (this.bio.bio_id) {
          return this.appUrl.media + "/" + this.bio.img;
        }
        if (!this.bio.bio_id && !this.bio.img) {
          return "../../static/img/avatar.png";
        }
        if (
          typeof this.bio.img !== "object" &&
          this.bio.img &&
          !this.bio.bio_id
        ) {
          return this.bio.img;
        }
        if (
          typeof this.bio.img === "object" &&
          this.bio.img &&
          !this.bio.bio_id
        ) {
          return this.bio.imgSrc;
        }
        // return this.appUrl.media + "/" + this.bio.img
      }
    },
    async mounted() {
      await this.getBio();
      this.instructor = await this.checkInstructor()
      this.checkInstructorSpecial()
    },
    destroyed() {
      this.$store.commit("dashboardProfile/CLEAR_BIO");
    },
    methods: {
      cookieSet() {
        this.$store.dispatch('auth/setCookie', {cname: 'user', cvalue: JSON.stringify(this.bio), exdays: 365})
      },
      async join() {
        let filterUrl = this.url.toLowerCase()
        this.url = filterUrl
        await this.$store.dispatch("dashboardProfile/setSpecial", {url: filterUrl});
        //  this.checkInstructorSpecial()
      },
      handleUploaded(resp) {
        this.userAvatar = resp.relative_url;
      },
      getBio() {
        this.$store.dispatch("dashboardProfile/getBio");
      },
      checkInstructorSpecial() {
        this.url = this.$store.state.dashboardProfile.url
      },
      getFile(file, e) {
        if (!this.bio.img) {
          this.bio.img = file;
        } else {
          this.updateAvatar(file, e);
        }
      },
      updateAvatar(fileData, event) {
        this.$store.dispatch("dashboardProfile/updateAvatar", {
          fileData,
          event
        });
      },
      showErr(errors) {
        for (let i = 0; i < errors.length; i++) {
          let elm = errors[i]

          this.$root.showWarnMsg({
            message: elm.msg
          });
        }
      },
      async updateBio() {
        let result = await this.$validator.validate();
        if (!result) {
          this.showErr(this.$validator.errors.items)
          this.$root.showWarnMsg({
            message: "لطفا فرم را تکمیل کنید ... "
          });
          return;
        }
        if (!this.bio.bio_id) {
          this.saveBio();
          return;
        }
        this.isLoading = true;
        await this.$store.dispatch("dashboardProfile/updateBio", this.bio);
        await this.$store.dispatch("dashboardProfile/updateFullname", {
          fullname: this.bio.fullname
        });
        this.isLoading = false;
      },
      async saveBio() {
        this.$store.dispatch("dashboardProfile/updateFullname", {
          fullname: this.bio.fullname
        });
        if (!this.bio.img) {
          this.$root.showWarnMsg({
            message: "لطفا عکس حود را ضمیمه کنید."
          });
          return
        }
        this.isLoading = true;

        try {
          await this.$store.dispatch("dashboardProfile/saveBio", this.bio);
          this.isLoading = false;
          if (this.$router.query && this.$router.query.page) {
            this.$router.push(this.$router.query.page);
          }
        } catch (error) {
          console.log(error);

        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .profile {
    display: block;

    &-img {
      max-width: 175px;
      max-height: 175px;
    }
  }

  .text-red {
    color: #9e2f2f;
  }

  .group-form-social {
    display: flex;
    justify-content: flex-start;
    flex-direction: row-reverse;
    position: relative;
    align-items: center;
    height: 80px;

    .is-danger {
      position: absolute;
      bottom: 0;
      left: 0;
    }

    input {
      border: 1px solid gray;
      border-left: none;
      padding: 7px 2px;
      height: 32px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      width: 100%;
    }

    strong {
      font-weight: inherit;
      background-color: gray;
      color: #fff;
      height: 32px;
      padding: 5px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      font-size: 14px;
    }

    label {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/profile.vue